<template>
	<div class="molecular-modal">
		<button class="molecular-modal-btn" @click="modal = !modal">See Molecular Scale</button>
		<!-- TODO: Get Microscope Icon -->

		<transition name="modal" mode="out-in">
			<div class="modal-background" @click.self="modal = false" v-if="modal">
				<div class="modal-body">

					<p>For the sake of simplicity, anions and water molecules are not shown in this animation.</p>

					<div class="spheres" :class="{ 'absorb' : endMetal !== false && !specialSilver, 'bounce' : endMetal === false && !specialSilver, 'special-silver' : specialSilver }">
						<template v-for="i in 8">
							<template v-for="j in 2">

								<div 
									class="bigsphere" 
									:class="
										[
											metalAbbr, 
											(i === 3 || i === 5) && j === 2 && !specialSilver  ? 'mover' : '',
											(i === 3) && j === 2 && specialSilver  ? 'mover' : ''
										]" 
									:style="`top:${i}em;left:${j}em`">

									<span class="charge" v-if="((i === 3 || i === 5) && j === 2 && !specialSilver) || ((i === 3) && j === 2 && specialSilver)">{{ charge > 1 ? charge : '' }}{{ specialSilver ? '2' : '' }}+</span>
									<span>{{ metalAbbr }}</span>
								</div>
							</template>
						</template>

						<div class="smallsphere" :class="chemicalAbbr" style="top:1em;right:0em;">
							<span class="charge">{{ charge > 1 ? charge : '' }}+</span>
							<span>{{ chemicalAbbr }}</span>
						</div>
						<div class="smallsphere sphere2" :class="chemicalAbbr" style="top:3em;right:0em;">
							<span class="charge">{{ charge > 1 ? charge : '' }}+</span>
							<span>{{ chemicalAbbr }}</span>
						</div>

						<div class="eee e1">
							<span>e<sup>−</sup></span>
							<span v-if="charge > 1 && !specialSilver" style="position:relative;top:10px;left:-5px;">e<sup>−</sup></span>
						</div>
						<div class="eee e2">
							<span>e<sup>−</sup></span>
							<span v-if="charge > 1 && !specialSilver" style="position:relative;top:10px;left:-5px;">e<sup>−</sup></span>
						</div>

					</div>

					<button class="modal-close btn" @click="modal=false">Dismiss</button>
				</div>
			</div>
		</transition>
	</div>
</template>


<script>
export default {
	name:"MolecularModal",
	props:{
		metal: String,
		formula: String,
		endMetal: [Boolean, String],
		charge: Number,
	},
	data() {
		return {
			modal: false,
			metalAbbr: '',
			chemicalAbbr: '',
			specialSilver: false
		}
	},
	methods: {
		getAbbr(metalFile){
			const metal = metalFile.replace('.png', '')
			switch (metal) {
				case 'copper':
					return 'Cu'
					break;
				case 'tin':
					return 'Sn'
					break
				case 'zinc':
					return 'Zn'
					break
				case 'silver':
					return 'Ag'
					break
				case 'nickel':
					return 'Ni'
					break
				case 'lead':
					return 'Pb'
					break
				case 'iron':
					return 'Fe'
					break
				case 'magnesium':
					return 'Mg'
					break;
			}
		}
	},
	beforeMount() {
		this.metalAbbr=this.getAbbr(this.metal)
		this.chemicalAbbr=this.formula.substring(0, 2);
		if((this.metalAbbr === 'Zn' || this.metalAbbr === 'Cu' || this.metalAbbr === 'Mg' ) && this.chemicalAbbr === 'Ag') this.specialSilver = true

	},
}
</script>


<style lang="scss" scoped>
	.spheres {
		width: 10em;
		height: 10em;
		overflow: hidden;
		font-size: 3em;
		position: relative;
	}
	.bigsphere, .smallsphere {
		position: absolute;
		border-radius: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		span { font-size: 0.3em; }	
	}
	.bigsphere {
		width: 1em;
		height: 1em;

		&.mover{
			.charge {
				position: absolute;
				top: -.5em;
				left: 100%;
				font-size: 1rem;
				color: #1eb25f;
				opacity: 0;
			}
		}
	}

	
	.smallsphere {
		width: 0.5em;
		height: 0.5em;
		
		// border: solid 3px transparent;
		box-sizing: border-box;
		span { 
			font-size: 0.2em; 
			border-radius: 100%;
		}	
		.charge {
			position: absolute;
			top: -0.3em;
			left: 100%;
			font-size: 0.6rem;
			color: #1eb25f;
		}
	}
	.eee {
		position: absolute;
		left: 2.5em;
		opacity: 0;
		&.e1{top: 2.3em;}
		&.e2{top: 4.4em;}
		span { font-size: 0.3em; color: red; }	
		
	}

	.special-silver{
		.eee{
			&.e2{
				top: 2.8em;
			}
		}
	}


	.Cu{
			background: linear-gradient(to right, darken(#C48226, 20%), #C48226, lighten(#C48226, 15%));
			color: #fff;
		}

		.Mg{
			background: linear-gradient(to right, darken(#cacaca, 20%), #cacaca, lighten(#cacaca, 15%));
			color: #000;
		}

		.Zn{
			background: linear-gradient(to right, darken(#797979, 20%), #797979, lighten(#797979, 15%));
			color: #000;
		}

		.Ag{
			background: linear-gradient(to right, darken(#C2C4C5, 20%), #C2C4C5, lighten(#C2C4C5, 15%));
			color: #000;
		}

		.Fe{
			background: linear-gradient(to right, darken(#9A9A9A, 20%), #9A9A9A, lighten(#9A9A9A, 15%));
			color: #fff;
		}

		.Sn{
			background: linear-gradient(to right, darken(#CACACA, 20%), #CACACA, lighten(#CACACA, 15%));
			color: #000;
		}

		.Pb{
			background: linear-gradient(to right, darken(#1D1D1D, 20%), #1D1D1D, lighten(#1D1D1D, 15%));
			color: #fff;
		}

		.Ni{
			background: linear-gradient(to right, darken(#898B8D, 20%), #898B8D, lighten(#898B8D, 15%));
			color: #fff;
		}

		.absorb{
			.mover{
				animation: moveBigBalls linear 10s;
				animation-iteration-count: infinite; //1;
				transform-origin: 50% 50%;
				animation-fill-mode: forwards;
				animation-timing-function: ease;
			}	

			.smallsphere{
				animation: moveSmallBalls linear 10s;
				animation-iteration-count: infinite; //1;
				transform-origin: 50% 50%;
				animation-fill-mode: forwards;
				animation-timing-function: ease;
			}

			.smallsphere .charge{
				animation: incomingCharge linear 10s;
				animation-iteration-count: infinite; //1;
				transform-origin: 50% 50%;
				animation-fill-mode: forwards;
				animation-timing-function: ease;
			}
			.bigsphere .charge{
				animation: outgoingCharge linear 10s;
				animation-iteration-count: infinite; //1;
				transform-origin: 50% 50%;
				animation-fill-mode: forwards;
				animation-timing-function: ease;
			}

			.eee{
				animation: moveEEE linear 10s;
				animation-iteration-count: infinite; //1;
				transform-origin: 50% 50%;
				animation-fill-mode: forwards;
				animation-timing-function: ease;
			}
		}

		.bounce{
			.smallsphere{
				animation: bounceSmallBalls linear 10s;
				animation-iteration-count: infinite; //1;
				transform-origin: 50% 50%;
				animation-fill-mode: alternate;
				animation-timing-function: linear;
			}
		}

		.special-silver{
			.mover{
				animation: moveBigBalls linear 10s;
				animation-iteration-count: infinite; //1;
				transform-origin: 50% 50%;
				animation-fill-mode: forwards;
				animation-timing-function: ease;
			}	
			.smallsphere{
				animation: specialSilverSmallBalls linear 10s;
				animation-iteration-count: infinite; //1;
				transform-origin: 50% 50%;
				animation-fill-mode: alternate;
				animation-timing-function: ease;

				&.sphere2{
					animation: specialSilverSmallBalls2 linear 10s;
					animation-iteration-count: infinite; //1;
					transform-origin: 50% 50%;
					animation-fill-mode: alternate;
					animation-timing-function: ease;
				}
			}

			.smallsphere .charge{
				animation: incomingCharge linear 10s;
				animation-iteration-count: infinite; //1;
				transform-origin: 50% 50%;
				animation-fill-mode: forwards;
				animation-timing-function: ease;
			}
			.bigsphere .charge{
				animation: outgoingCharge linear 10s;
				animation-iteration-count: infinite; //1;
				transform-origin: 50% 50%;
				animation-fill-mode: forwards;
				animation-timing-function: ease;
			}

			.eee{
				animation: moveEEE linear 10s;
				animation-iteration-count: infinite; //1;
				transform-origin: 50% 50%;
				animation-fill-mode: forwards;
				animation-timing-function: ease;
			}
		}

		@keyframes moveSmallBalls{
			0% {
				transform: translate(0,0) rotate(0deg);
			}
			35% {
				transform: translate(-6.6em,1.7em) rotate(20deg);
				width: 0.5em;
				height: 0.5em;
				// border-color: #ccffd8;
			}

			45%{
				width: 1em;
				height: 1em;
			}

			55%{
				transform: translate(-6.2em,1.6em) rotate(0deg);
				width: 1em;
				height: 1em;
				// border-color: #ccffd8;
			}

			60%{
				transform: translate(-6.2em,1.6em) rotate(0deg);
				width: 1em;
				height: 1em;
				// border-color: transparent;
			}

			100%{
				transform: translate(-6.2em,1.6em) rotate(0deg);
				width: 1em;
				height: 1em;
			}
		}

		@keyframes specialSilverSmallBalls{
			0% {
				// transform: translate(0,0) rotate(0deg);
			}
			35% {
				// transform: translate(-6.6em,2em) rotate(20deg);
				top: 2.8em;
				right: 6.5em;
				width: 0.5em;
				height: 0.5em;
				// border-color: #ccffd8;
			}

			45%{
				width: 1em;
				height: 1em;
			}

			55%{
				// transform: translate(-6.6em,2em) rotate(20deg);
				top: 2.5em;
				right: 6.1em;
				width: 1em;
				height: 1em;
				// border-color: #ccffd8;
			}

			60%{
				// transform: translate(-6.6em,2em) rotate(20deg);
				top: 2.5em;
				right: 6.1em;
				width: 1em;
				height: 1em;
				// border-color: transparent;
			}

			100%{
				// transform: translate(-6.6em,2em) rotate(20deg);
				top: 2.5em;
				right: 6.1em;
				width: 1em;
				height: 1em;
			}
		}
		@keyframes specialSilverSmallBalls2{
			0% {
				// transform: translate(0,0) rotate(0deg);
			}
			35% {
				// transform: translate(-6.6em,2em) rotate(20deg);
				top: 3.3em;
				right: 6.6em;
				width: 0.5em;
				height: 0.5em;
				// border-color: #ccffd8;
			}

			45%{
				width: 1em;
				height: 1em;
			}

			55%{
				// transform: translate(-6.6em,2em) rotate(20deg);
				top: 3.5em;
				right: 6.15em;
				width: 1em;
				height: 1em;
				// border-color: #ccffd8;
			}

			60%{
				// transform: translate(-6.6em,2em) rotate(20deg);
				top: 3.5em;
				right: 6.15em;
				width: 1em;
				height: 1em;
				// border-color: transparent;
			}

			100%{
				// transform: translate(-6.6em,2em) rotate(20deg);
				top: 3.5em;
				right: 6.15em;
				width: 1em;
				height: 1em;
			}
		}

		@keyframes bounceSmallBalls{
			0% { transform: translate(0,1em) rotate(0deg); }
			30% { transform: translate(-6.5em,2.7em) rotate(20deg); }
			60%{ transform: translate(1em,2em) rotate(120deg); }
			100% { transform: translate(1em,2em) rotate(120deg); }
		}

		@keyframes moveEEE{
			0%{
				opacity: 0;
				left: 2.5em;
			}

			25%{
				opacity: 0;
				left: 2.5em;
			}

			35%{
				opacity: 1;
				left: 2.5em;
			}

			50%{
				opacity: 1;
				left: 3em;
			}

			55%{
				opacity: 0;
				left: 3em;
			}


			100%{
				opacity: 0;
				left: 3em;
			}
		}

		@keyframes moveBigBalls{
			0%{
				transform: scale(1) translateX(0);
			}

			35%{
				transform: scale(1) translateX(0);
			}

			45%{
				transform: scale(.5) translateX(0em);
			}

			50%{
				transform: scale(.5) translateX(0em);
			}

			70%{
				opacity: 1;
			}

			80%{
				opacity: 0;
			}

			100%{
				opacity: 0;
				transform: scale(.5) translateX(20em);
			}
		}

		@keyframes incomingCharge {
			0%{
				opacity: 1;
			}
			35%{
				opacity: 1;
			}

			45%{
				opacity: 0;
			}

			100%{
				opacity: 0;
			}
		}

		@keyframes outgoingCharge {
			0%{
				opacity: 0;
				transform: scale(1);
			}
			35%{
				opacity: 0;
				transform: scale(1);
			}

			45%{
				opacity: 1;
				transform: scale(1.5);
			}

			100%{
				opacity: 1;
				transform: scale(1.5);
			}
		}



	.molecular-modal{

		.molecular-modal-btn{
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			border:1px solid $bordergrey;
			color: $grey;
			background: #fff;
			padding: .3em 1.4em;
			border-radius: 3em;
			font-size: .7rem;
			font-weight: 400;
			white-space: nowrap;
			transition: all 250ms;

			&:hover{
				border-color: $blue;
				background: $blue;
				color: #fff;
			}

			@media screen and (min-width: 480px) {
				font-size: 1em;
			}
		}
	}

	.modal-background{
		background: rgba($green, 0.9);
		@supports(backdrop-filter: blur(10px)){
			background: rgba($green, 0.3);
			backdrop-filter: blur(10px);
		}
		position: fixed;
		top: 0px;
		left: 0%;
		width: 100%;
		height: 100%;
		z-index: 1000;
		padding: 1em;
		display: flex;
		justify-content: center;
		align-items: center;
		overflow-y: scroll;


		.modal-body{
			background: #fff;
			padding: 2em;
			border-radius: 1em;
			width: 90%;
			max-width: 680px;
			text-align: center;
			p { font-size: 0.7em; color: #aaa; }
		}
	}

	.modal-enter-active, .modal-leave-active {
		transition: all 500ms;

		.modal-body{
			transition: all 500ms;
		}
	}
	.modal-enter, .modal-leave-to {
		opacity: 0;

		.modal-body{
			transform: translateY(100px);
		}
	}
</style>